import React from "react";

const labelStyles = "text-gray pl-2 font-medium cursor-pointer select-none";
const InputLabel = ({
  id,
  label,
  isRequired,
  formatError,
  className,
  htmlFor,
}: {
  id: string;
  label: string;
  isRequired?: boolean;
  formatError?: boolean;
  className?: string;
  htmlFor?: string;
}) => (
  <div data-testid={id}>
    <label
      className={`${labelStyles} ${
        formatError ? "text-red font-semibold" : ""
      } ${className ?? ""}`}
      htmlFor={htmlFor ?? label}
    >
      {label}
    </label>
    {isRequired && (
      <p className="inline-block ml-[5px] pt-[2px] text-red-500 align-[-3px]">
        *
      </p>
    )}
  </div>
);

export default InputLabel;
